/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    //redirect: '/dashboard/analytics'
                    // redirect: '/apps/Barretts/patients'
                    redirect: '/apps/DELTA/patients'
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboardAnalytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/dashboard/delta',
                    name: 'dashboardDelta',
                    component: () => import('./views/DashboardDeltaFiltered.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/dashboard/map',
                    name: 'dashboardMap',
                    component: () => import('./views/DashboardDeltaMap.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },

        // =============================================================================
        // Application Routes
        // =============================================================================

                {
                    path: '/apps/Barretts/patients',
                    name: 'Patients',
                    component: () => import('./views/apps/Barretts/Patients.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Barretts'},
                            { title: 'Patients', active: true },
                        ],
                        pageTitle: 'Patients',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Barretts/patients/view/:participant_id',
                    name: 'Patient view',
                    component: () => import('./views/apps/Barretts/PatientView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Barretts' },
                            { title: 'Patients', url: '/apps/Barretts/patients' },
                            { title: 'View', active: true },
                        ],
                        pageTitle: 'Patient',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Barretts/patient-add',
                    name: 'PatientsAdd',
                    component: () => import('./views/apps/Barretts/PatientsAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Barretts'},
                            { title: 'Add patient', active: true },
                        ],
                        pageTitle: 'Add patient',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Barretts/samples',
                    name: 'Samples',
                    component: () => import('./views/apps/Barretts/Samples.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Barretts'},
                            { title: 'Samples', active: true },
                        ],
                        pageTitle: 'Samples',
                        rule: 'editor'
                    }
                },
                /***
                {
                    path: '/apps/MDT/patients',
                    name: 'MDT',
                    component: () => import('./views/apps/MDT/Patients.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'MDT'},
                            { title: 'Patients', active: true },
                        ],
                        pageTitle: 'MDT',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/MDT2/patients',
                    name: 'MDT2',
                    component: () => import('./views/apps/MDT2/Patients.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'MDT2'},
                            { title: 'Patients', active: true },
                        ],
                        pageTitle: 'MDT2',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Barretts/reports',
                    name: 'Patients',
                    component: () => import('./views/apps/Barretts/Reports.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Barretts'},
                            { title: 'Reports', active: true },
                        ],
                        pageTitle: 'Reports',
                        rule: 'editor'
                    }
                },

                {
                    path: '/app/informatics/patients',
                    name: 'InformaticsPatients',
                    //component: () => import('./views/apps/Informatics/Patients/Search.vue'),
                    component: () => import('./views/apps/Informatics/Sequencing/Search.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Informatics'},
                            { title: 'Patients'},
                            { title: 'Search', active: true },
                        ],
                        pageTitle: 'Patients',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/OCCAMS/patients',
                    name: 'OCCAMS',
                    component: () => import('./views/apps/OCCAMS/Patients.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'Informatics'},
                          { title: 'OCCAMS'},
                          { title: 'Search', active: true },
                        ],
                        pageTitle: 'OCCAMS',
                        rule: 'editor'
                    }
                },
                {
                    path: '/app/informatics/masterpath',
                    name: 'InformaticsMasterpath',
                    //component: () => import('./views/apps/Informatics/Patients/Search.vue'),
                    component: () => import('./views/apps/Informatics/Masterpath/Search.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Informatics'},
                            { title: 'Masterpath'},
                            { title: 'Search', active: true },
                        ],
                        pageTitle: 'Masterpath',
                        rule: 'editor'
                    }
                },
                {
                    path: '/app/informatics/masterlist',
                    name: 'InformaticsMasterlist',
                    component: () => import('./views/apps/Informatics/Masterlist/Search.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Informatics'},
                            { title: 'Masterlist'},
                            { title: 'Search', active: true },
                        ],
                        pageTitle: 'Masterlist',
                        rule: 'editor'
                    }
                },
                {
                    path: '/app/informatics/samples',
                    name: 'OCCAMS Samples',
                    component: () => import('./views/apps/Informatics/OCSamples/Patients.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'Informatics'},
                          { title: 'Samples'},
                          { title: 'Search', active: true },
                        ],
                        pageTitle: 'OCCAMS Samples',
                        rule: 'editor'
                    }
                },
                {
                    path: '/app/informatics/sequencing/add',
                    name: 'AddSequencing',
                    component: () => import('./views/apps/Informatics/Sequencing/Add.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Informatics'},
                            { title: 'Sequencing'},
                            { title: 'Add sequencing', active: true },
                        ],
                        pageTitle: 'Add sequencing',
                        rule: 'editor'
                    }
                },
                ***/
                {
                    path: '/apps/delta/patients',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/Search.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Search', active: true },
                        ],
                        pageTitle: 'DELTA',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/patients/view/:delta_case_id',
                    name: 'Patient view',
                    component: () => import('./views/apps/delta/CaseView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'DELTA' },
                            { title: 'Patients', url: '/apps/delta/patients' },
                            { title: 'View', active: true },
                        ],
                        pageTitle: 'Case',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/patient/add',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/CaseAdd.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Add new', active: true },
                        ],
                        pageTitle: 'DELTA | Add new case',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/resources/crf',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/resources/CRF.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Resources'},
                          { title: 'CRF download', active: true },
                        ],
                        pageTitle: 'CRF download library',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/resources/export',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/resources/Export.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Resources'},
                          { title: 'Export', active: true },
                        ],
                        pageTitle: 'Export',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/resources/check',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/resources/Check.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Resources'},
                          { title: 'Check missing', active: true },
                        ],
                        pageTitle: 'Check missing',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/users',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/users/Search.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Users', active: true },
                        ],
                        pageTitle: 'Users',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/groups',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/users/Search.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Groups', active: true },
                        ],
                        pageTitle: 'Groups',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/delta/sites',
                    name: 'DELTA',
                    component: () => import('./views/apps/delta/users/Search.vue'),
                    meta: {
                        breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'DELTA'},
                          { title: 'Sites', active: true },
                        ],
                        pageTitle: 'Sites',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Settings/settings',
                    name: 'Settings',
                    component: () => import('./views/apps/Settings/Settings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings'},
                            { title: 'Settings', active: true },
                        ],
                        pageTitle: 'Settings',
                        rule: 'editor'
                    }
                },
                {
                    path: '/apps/Settings/users',
                    name: 'Users',
                    component: () => import('./views/apps/Settings/Users.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings'},
                            { title: 'Users', active: true },
                        ],
                        pageTitle: 'Users',
                        rule: 'editor'
                    }
                },

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/callback',
                    name: 'authCallback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/login',
                    name: 'pageLogin',
                    component: () => import('@/views/pages/Login.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/calculator',
                    name: 'pageCalculator',
                    component: () => import('@/views/pages/Calculator.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'pageRegister',
                    component: () => import('@/views/pages/Register.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'pageForgotPassword',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'pageResetPassword',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'pageLockScreen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/comingsoon',
                    name: 'pageComingSoon',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'pageError404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'pageError500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'pageNotAuthorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'pageMaintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  let loggedIn = localStorage.getItem('user');

  // Check expiry
  const tokenExpiry = localStorage.getItem('tokenExpiry');
  if (tokenExpiry > 0 && Date.now() > tokenExpiry) { loggedIn = false; }
  // console.log('EXPIRY');
  // console.log(tokenExpiry);
  // console.log(Date.now());

  if (
      to.path === "/pages/login" ||
      to.path === "/pages/forgot-password" ||
      to.path === "/pages/error-404" ||
      to.path === "/pages/error-500" ||
      to.path === "/pages/register" ||
      to.path === "/callback" ||
      to.path === "/pages/comingsoon" ||
      to.path === "/calculator" ||
      loggedIn
  ) {
      return next();
  }

  router.push({ path: '/pages/login', query: { to: to.path } });
});
// router.beforeEach((to, from, next) => {
//     firebase.auth().onAuthStateChanged(() => {
//
//         // get firebase current user
//         const firebaseCurrentUser = firebase.auth().currentUser;
//
//         if (
//             to.path === "/pages/login" ||
//             to.path === "/pages/forgot-password" ||
//             to.path === "/pages/error-404" ||
//             to.path === "/pages/error-500" ||
//             to.path === "/pages/register" ||
//             to.path === "/callback" ||
//             to.path === "/pages/comingsoon" ||
//             (auth.isAuthenticated() || firebaseCurrentUser)
//         ) {
//             return next();
//         }
//
//         router.push({ path: '/pages/login', query: { to: to.path } })
//         // Specify the current path as the customState parameter, meaning it
//         // will be returned to the application after auth
//         // auth.login({ target: to.path });
//
//     });
//
// });

export default router
